let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1kb22"), load("1fnbu")]).then(() => parcelRequire('m0wkE'));